import { render } from "./CompanyIntroduction.vue?vue&type=template&id=f5b2ff80&scoped=true"
import script from "./CompanyIntroduction.vue?vue&type=script&lang=js"
export * from "./CompanyIntroduction.vue?vue&type=script&lang=js"

import "./CompanyIntroduction.vue?vue&type=style&index=0&id=f5b2ff80&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5b2ff80"]])

export default __exports__